import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import basicgOperations from '@/mixins/basic-operations'
import dateOperations from '@/mixins/date-operations'
import icons from '@/mixins/icons.js'
import kalender from '@/components/utils/kalender/kalender.vue'

export default {
  name: 'GebruikerAanmaken',

  mixins: [stringOperations, dateOperations, basicgOperations, icons],
  components: {
    kalender
  },

  data() {
    var vandaag = new Date()
    return {

      rollen: this.$store.state.rollen,
      user: {
        email: '',
        PW: '',
        PW2: '',
        Familienaam: '',
        Datum: '',
        Voornaam: '',
        Rol: 0,
        Koppelcode: '',
        acceptPrivacy: false
      },
      // datumChild:this._formatDateSQL(new Date()),
      // this._formatDateSQL(new Date(1988, 17, 4))
      datumKalenderId: 'datumKalenderId',
      Key: '',
      ID: '',

      melding: '',
      succes: false,
      PWMin8: true,
      PWSpecialChars: false,
      // eslint-disable-next-line no-undef
      privateUrl: WISA.ClientConf.PrivacyURL,
      passwordsValid: false,
      passwordsInfo: [],
      emailInfo: '',
      firstnameInfo: '',
      nameInfo: '',
      dateInfo: '',
      serverLocation: null,
      passwordFieldType: 'password',
      serverLocationOfSelectedConnection: ''
      //'Test1!',
    }
  },

  computed: {

    matchingPassword() {
      if (this.user.PW !== "" && this.user.PW2 !== "") {
        return this.user.PW === this.user.PW2;
      } else {
        return false;
      }
    },


  },

  beforeDestroy() {
    // this.$store.commit(mutationTypes.SET_SHOW_TOP_LOGO, false)
  },

  mounted: function () {
    console.log('gebruiker-aanmaken')

    this.PWMin8 = this.$store.state.api.PWMin8
    this.PWSpecialChars = this.$store.state.api.PWSpecialChars


    this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
      left: 'back',
      title: 'Gebruiker aanmaken',
      right: []
    })


    this.user = {
      email: '',
      PW: '',
      PW2: '',
      Familienaam: '',
      Voornaam: '',
      Rol: {
        label: 'Student',
        value: 0
      },
      Koppelcode: '',
      Datum: this._formatDateSQL(new Date()),
      acceptPrivacy: false
    }

    this.passwordsInfo = this._passwordValidation(this.user.PW, this.user.PW2, this.PWMin8, this.PWSpecialChars)
    this.emailInfo = this._emailValidation(this.user.email)

    //this.serverLocation = this.$store.state.userInfo.loggedInConnectionObject.serverLocation
    if (this.$route.params.id !== undefined) {
      var connectionObject = this.$store.getters.getConnectionWithID(this.$route.params.id);
      this.serverLocationOfSelectedConnection = connectionObject.serverLocation
    }
    // Schoolware url!
    else {
      let path = window.location;
      let origin = path.origin;
      let pathname = path.pathname;
      let arrayPathname = pathname.split("/");
      //production
      let index = ''
      if (arrayPathname.length > 0) {

        index = arrayPathname.indexOf("webstudent");
      }
      if (index === -1 || index === '-1') {
        this.serverLocationOfSelectedConnection = origin
      } else {
        this.serverLocationOfSelectedConnection = origin + '/webstudent'

      }

      // dev:
      //  this.serverLocationOfSelectedConnection = "http://localhost/webstudent/";
      // this.serverLocationOfSelectedConnection = 'https://9db9b0e699fe.ngrok.io/webstudent/'

    }

  },

  methods: {


    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },

    createAccount() {
      console.log('createRequest')
      this.$store.dispatch('createRequest', {
        dezeDit: this
      })
    },

    firstnameChanged: function () {
      this.firstnameInfo = this._min1characterValidation(this.user.Voornaam)
    },

    nameChanged: function () {
      this.nameInfo = this._min1characterValidation(this.user.Familienaam)
    },

    emailChanged: function () {
      this.emailInfo = this._emailValidation(this.user.email)
    },

    passwordChanged: function () {
      this.passwordsInfo = this._passwordValidation(this.user.PW, this.user.PW2, this.PWMin8, this.PWSpecialChars)
    },

    dateChangedFunction: function (date) {
      console.log('dateChangedFunction')
      this.dateInfo = this._dateValidation(this.user.Datum, 'YYYY-MM-DD')
      this.user.Datum = date
    },

    /* datumGewijzigd(date) {
       console.log('datumGewijzigd')
       this.dateInfo = this._dateValidation(this.user.Datum, 'YYYY-MM-DD')
     },*/

  }
}
